import React, { useCallback, useEffect, useState } from 'react'
import { CircularProgress, Divider, Grid, Typography } from '@material-ui/core'
import { useDescricaoTecnicaVestigioService } from 'hooks/useDescricaoTecnicaVestigioService'
import { getLabelTipoExameRealizado } from 'helpers/labels'
import { DadosEspecificos } from '../DadosEspecificos'
import useStyles from './styles'
import { ExibirArquivo } from 'components/ExibirArquivo'

export const DetailPanel = (props) => {
  const { tipoExame } = props
  const classes = useStyles()
  const descricaoTecnicaVestigioService = useDescricaoTecnicaVestigioService()
  const { idDescricaoTecnica, tipoVestigio, children } = props //eslint-disable-line
  const [descricaoTecnica, setDescricaoTecnica] = useState(null) //eslint-disable-line
  const [processandoDescricaoTecnica, setProcessandoDescricaoTecnica] = useState(false) //eslint-disable-line

  const fetchDescricaoTecnicaVestigio = useCallback(async () => {
    if (idDescricaoTecnica) {
      const response = await descricaoTecnicaVestigioService.listarDescricaoTecnicaVestigioDadosEspecificosAsync(idDescricaoTecnica, tipoVestigio, setProcessandoDescricaoTecnica)
      setDescricaoTecnica(response)
    }
  }, [])

  useEffect(() => {
    fetchDescricaoTecnicaVestigio()
  }, [fetchDescricaoTecnicaVestigio])

  return (
    <div>
      {processandoDescricaoTecnica || !descricaoTecnica ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <Grid container md={12} sm={12} xs={12} className={classes.corpo}>
          <Grid item>
            <Typography>
              <b>DADOS GERAIS</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Divider className={classes.dividerTitle} />
          </Grid>
          <Grid item container md={12} sm={12} xs={12} className={classes.grupoEspelho}>
            <Grid item md={6} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>EXAME RESPONSÁVEL PELA DESCRIÇÃO</b>
              </Typography>
              <Typography variant="body2">
                {descricaoTecnica?.exReal?.numeroExame} - {getLabelTipoExameRealizado(descricaoTecnica?.exReal?.tipo)?.toUpperCase()}
              </Typography>
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              <Typography className={classes.dadoEspelho}>
                <b>DESCRITO POR</b>
              </Typography>
              <Typography variant="body2">{descricaoTecnica?.exReal?.usuExams?.map((usuario) => usuario.nome?.toUpperCase()).join(', ')}</Typography>
            </Grid>

            {(descricaoTecnica.tipoVestigioGenerico === 'GERAL' ||
              descricaoTecnica.tipoVestigioGenerico === 'BIOLOGICO' ||
              descricaoTecnica.tipoVestigioGenerico === 'DOCUMENTAL' ||
              descricaoTecnica.tipoVestigioGenerico === 'ELETRONICO' ||
              descricaoTecnica.tipoVestigioGenerico === 'PAPILOSCOPICO' ||
              descricaoTecnica.tipoVestigioEspecifico === 'OUTRO') && (
              <Grid item md={12} sm={12} xs={12}>
                <Typography className={classes.dadoEspelho}>
                  <b>DESCRIÇÃO</b>
                </Typography>
                <Typography variant="body2">{descricaoTecnica.descricao?.toUpperCase()}</Typography>
              </Grid>
            )}
          </Grid>

          {descricaoTecnica.tipoVestigioGenerico === 'QUIMICO' && <DadosEspecificos valores={descricaoTecnica.descVestQuim} dadosDescricaoTecnicaPai={descricaoTecnica} tipoVestigioGenerico={descricaoTecnica.tipoVestigioGenerico} tipoVestigioEspecifico={descricaoTecnica.tipoVestigioEspecifico} />}
          {descricaoTecnica.tipoVestigioGenerico === 'BALISTICO' && <DadosEspecificos valores={descricaoTecnica.descVestBal} dadosDescricaoTecnicaPai={descricaoTecnica} tipoVestigioGenerico={descricaoTecnica.tipoVestigioGenerico} tipoVestigioEspecifico={descricaoTecnica.tipoVestigioEspecifico} tipoExame={tipoExame}/>}

          {children}

          <Grid item md={12} sm={12} xs={12} style={{ marginTop: '10px' }}>
            <Typography>
              <b>IMAGENS</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Divider className={classes.dividerTitle} />
          </Grid>
          {descricaoTecnica.arqs?.length ? (
            <Grid item md={12} sm={12} xs={12}>
              <Grid container justifyContent="flex-start" alignItems="center">
                {descricaoTecnica.arqs.map((arquivo) => (
                  <Grid className={classes.item} item md={2} sm={4} xs={8}>
                    <ExibirArquivo id={arquivo.id} rotaLoadFile={`/arquivo/descricaoTecnica/examinador`} />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          ) : (
            <Grid container justifyContent="center" alignItems="center" style={{ padding: '50px' }}>
              <Typography>Nenhum arquivo relacionado</Typography>
            </Grid>
          )}
        </Grid>
      )}
    </div>
  )
}
